
import React from 'react';

interface StarIconProps extends React.SVGProps<SVGSVGElement> {}

const BlueFlagIcon: React.FC<StarIconProps> = (props) => (
  <svg 
    xmlns="http://www.w3.org/2000/svg" 
    viewBox="0 0 24 24" 
    fill="currentColor" 
    {...props}
  >
    <path 
      fillRule="evenodd" 
      d="M4.5 3.75a3 3 0 0 0-3 3v10.5a3 3 0 0 0 3 3h15a3 3 0 0 0 3-3V6.75a3 3 0 0 0-3-3h-15Zm4.125 3.375c0-.518.408-.938.915-.938h4.046c.448 0 .859.248.915.641l.339 2.286a.75.75 0 0 1-.915.824l-4.046-.693a.75.75 0 0 1-.606-.735V7.125Z" 
      clipRule="evenodd" 
    />
  </svg>
);

export default BlueFlagIcon;